export enum RateType {
  Undefined = 'Undefined',
  Fixed = 'Fixed',
  Renewal = 'Renewal',
  Variable = 'Variable',
}
